import { Outlet, useNavigate, useLocation } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, LogOut } from "lucide-react";
import { jwtDecode } from "jwt-decode";

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  
  useEffect(() => {
    const token = localStorage.getItem("membreToken");

    if (!token) {
      navigate("/");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      if (decoded.role !== "admin") {
        navigate("/");
      }
    } catch {
      localStorage.removeItem("membreToken");
      navigate("/");
    }
  }, [navigate]);

  function logout() {
  localStorage.removeItem("membreToken");
  localStorage.removeItem("membre");
  localStorage.removeItem("membreExpiresAt");

  toast.success("Déconnexion réussie !");
  navigate("/");
}


  return (
    <div className="flex bg-gray-100 min-h-screen">

      
      <aside className="hidden md:block w-64 fixed left-0 top-0 h-full bg-white border-r z-40">
        <AdminSidebar closeMenu={() => {}} />
      </aside>

      
      <AnimatePresence>
        {sidebarOpen && (
          <>
            <motion.div
              className="fixed inset-0 bg-black/50 z-40 md:hidden"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSidebarOpen(false)}
            />

            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "tween", duration: 0.3 }}
              className="fixed left-0 top-0 h-full z-50 md:hidden bg-white"
            >
              <AdminSidebar closeMenu={() => setSidebarOpen(false)} />
            </motion.div>
          </>
        )}
      </AnimatePresence>

      
      <div className="flex-1 md:ml-64 flex flex-col min-h-screen">

        
        <header className="md:hidden sticky top-0 z-30 bg-white border-b">
          <div className="flex items-center justify-between px-4 py-3">

            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2 rounded-lg bg-blue-600 text-white"
            >
              <Menu size={22} />
            </button>

            <div className="flex items-center gap-2">
              <img
                src="/images/aleoa.jpg"
                alt="Logo Association"
                className="w-6 h-6 object-contain"
              />
              <span className="font-bold text-sm">Espace Admin</span>
            </div>

            <button
              onClick={logout}
              className="p-2 rounded-lg bg-red-600 text-white"
            >
              <LogOut size={18} />
            </button>
          </div>
        </header>

        
        <main className="flex-1 p-4 sm:p-6 text-gray-900">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
